
export interface PERMISSIONS {
 "system": {
  "view": boolean,
  "update": boolean
 },
 "commons": {
  "production_model": {
   "create": boolean,
   "update": boolean,
   "delete": boolean
  },
  "room_uncertainty": {
   "create": boolean,
   "delete": boolean
  },
  "fixed_x_values": {
   "create": boolean,
   "delete": boolean
  },
  "root_cause": {
   "create": boolean,
   "update": boolean,
   "delete": boolean
  }
 },
 "user": {
  "view": boolean,
  "create": boolean,
  "update": boolean,
  "delete": boolean
 },
 "role": {
  "view": boolean,
  "create": boolean,
  "update": boolean
 },
 "local_server_auth": {
  "view": boolean,
  "create": boolean,
  "update": boolean,
  "delete": boolean
 },
 "svn_repository": {
  "view": boolean,
  "create": boolean,
  "update": boolean,
  "delete": boolean,
  "clean": boolean
 },
 "file_sync": {
  "view": boolean,
  "create": boolean,
  "update": boolean,
  "delete": boolean,
  "clean": boolean,
  "delete_file": {
   "view": boolean,
   "delete": boolean,
   "audit": boolean
  },
  "download_security_file": boolean
 },
 "testing": {
  "view": boolean,
  "setting": {
   "other_sequence_parameters": {
    "view": boolean,
    "create": boolean,
    "update": boolean,
    "delete": boolean
   },
   "filter": {
    "view": boolean,
    "create": boolean,
    "update": boolean,
    "delete": boolean
   },
   "batch_serial": {
    "view": boolean,
    "create": boolean,
    "update": boolean,
    "delete": boolean
   }
  },
  "matching": {
   "view": boolean,
   "delete": boolean,
   "undelete": boolean
  }
 },
 "fail_report": {
  "view": boolean,
  "create": boolean,
  "update": boolean,
  "delete": boolean,
  "comment": boolean
 },
 "rma_tracking": {
  "view": boolean,
  "receive": boolean,
  "repair": boolean,
  "return": boolean,
  "delete": boolean
 },
 "analyzed_unit": {
  "view": boolean,
  "create": boolean,
  "update": boolean,
  "delete": boolean
 },
 "issue_overview": {
  "view": boolean,
  "create": boolean,
  "update": boolean,
  "delete": boolean,
  "root_cause": {
   "create": boolean,
   "update": boolean,
   "delete": boolean
  }
 },
 "update_limit": {
  "view": boolean,
  "create": boolean,
  "update": boolean,
  "measurement": {
   "view": boolean,
   "create": boolean,
   "update": boolean,
   "delete": boolean
  }
 },
 "equipment": {
  "view": boolean,
  "create": boolean,
  "update": boolean,
  "delete": boolean,
  "comment": boolean,
  "confirm": boolean,
  "bundle_lock": boolean,
  "bundle_unlock": boolean,
  "bundle_retire": boolean,
  "type": {
   "create": boolean,
   "update": boolean,
   "delete": boolean
  },
  "device": {
   "create": boolean,
   "update": boolean,
   "delete": boolean
  },
  "brand": {
   "create": boolean,
   "update": boolean,
   "delete": boolean
  },
  "storage_place": {
   "create": boolean,
   "update": boolean,
   "delete": boolean
  },
  "calibration": {
   "view": boolean,
   "create": boolean,
   "update": boolean,
   "delete": boolean
  },
  "product": {
   "view": boolean,
   "create": boolean,
   "update": boolean,
   "delete": boolean
  },
  "location": {
   "create": boolean,
   "update": boolean,
   "delete": boolean
  },
  "team": {
   "create": boolean,
   "update": boolean,
   "delete": boolean
  },
  "model": {
   "create": boolean,
   "update": boolean,
   "delete": boolean
  },
  "part": {
   "create": boolean,
   "update": boolean,
   "delete": boolean
  }
 },
 "refurbishment": {
  "view": boolean,
  "create": boolean,
  "update": boolean,
  "delete": boolean
 }
}

let check = function(p: string) {
    return false;
}

export function retrievePermissions(check: (p: string) => boolean): PERMISSIONS {
    return {
 "system": {
  "view": check('system.view'),
  "update": check('system.update')
 },
 "commons": {
  "production_model": {
   "create": check('commons.production_model.create'),
   "update": check('commons.production_model.update'),
   "delete": check('commons.production_model.delete')
  },
  "room_uncertainty": {
   "create": check('commons.room_uncertainty.create'),
   "delete": check('commons.room_uncertainty.delete')
  },
  "fixed_x_values": {
   "create": check('commons.fixed_x_values.create'),
   "delete": check('commons.fixed_x_values.delete')
  },
  "root_cause": {
   "create": check('commons.root_cause.create'),
   "update": check('commons.root_cause.update'),
   "delete": check('commons.root_cause.delete')
  }
 },
 "user": {
  "view": check('user.view'),
  "create": check('user.create'),
  "update": check('user.update'),
  "delete": check('user.delete')
 },
 "role": {
  "view": check('role.view'),
  "create": check('role.create'),
  "update": check('role.update')
 },
 "local_server_auth": {
  "view": check('local_server_auth.view'),
  "create": check('local_server_auth.create'),
  "update": check('local_server_auth.update'),
  "delete": check('local_server_auth.delete')
 },
 "svn_repository": {
  "view": check('svn_repository.view'),
  "create": check('svn_repository.create'),
  "update": check('svn_repository.update'),
  "delete": check('svn_repository.delete'),
  "clean": check('svn_repository.clean')
 },
 "file_sync": {
  "view": check('file_sync.view'),
  "create": check('file_sync.create'),
  "update": check('file_sync.update'),
  "delete": check('file_sync.delete'),
  "clean": check('file_sync.clean'),
  "delete_file": {
   "view": check('file_sync.delete_file.view'),
   "delete": check('file_sync.delete_file.delete'),
   "audit": check('file_sync.delete_file.audit')
  },
  "download_security_file": check('file_sync.download_security_file')
 },
 "testing": {
  "view": check('testing.view'),
  "setting": {
   "other_sequence_parameters": {
    "view": check('testing.setting.other_sequence_parameters.view'),
    "create": check('testing.setting.other_sequence_parameters.create'),
    "update": check('testing.setting.other_sequence_parameters.update'),
    "delete": check('testing.setting.other_sequence_parameters.delete')
   },
   "filter": {
    "view": check('testing.setting.filter.view'),
    "create": check('testing.setting.filter.create'),
    "update": check('testing.setting.filter.update'),
    "delete": check('testing.setting.filter.delete')
   },
   "batch_serial": {
    "view": check('testing.setting.batch_serial.view'),
    "create": check('testing.setting.batch_serial.create'),
    "update": check('testing.setting.batch_serial.update'),
    "delete": check('testing.setting.batch_serial.delete')
   }
  },
  "matching": {
   "view": check('testing.matching.view'),
   "delete": check('testing.matching.delete'),
   "undelete": check('testing.matching.undelete')
  }
 },
 "fail_report": {
  "view": check('fail_report.view'),
  "create": check('fail_report.create'),
  "update": check('fail_report.update'),
  "delete": check('fail_report.delete'),
  "comment": check('fail_report.comment')
 },
 "rma_tracking": {
  "view": check('rma_tracking.view'),
  "receive": check('rma_tracking.receive'),
  "repair": check('rma_tracking.repair'),
  "return": check('rma_tracking.return'),
  "delete": check('rma_tracking.delete')
 },
 "analyzed_unit": {
  "view": check('analyzed_unit.view'),
  "create": check('analyzed_unit.create'),
  "update": check('analyzed_unit.update'),
  "delete": check('analyzed_unit.delete')
 },
 "issue_overview": {
  "view": check('issue_overview.view'),
  "create": check('issue_overview.create'),
  "update": check('issue_overview.update'),
  "delete": check('issue_overview.delete'),
  "root_cause": {
   "create": check('issue_overview.root_cause.create'),
   "update": check('issue_overview.root_cause.update'),
   "delete": check('issue_overview.root_cause.delete')
  }
 },
 "update_limit": {
  "view": check('update_limit.view'),
  "create": check('update_limit.create'),
  "update": check('update_limit.update'),
  "measurement": {
   "view": check('update_limit.measurement.view'),
   "create": check('update_limit.measurement.create'),
   "update": check('update_limit.measurement.update'),
   "delete": check('update_limit.measurement.delete')
  }
 },
 "equipment": {
  "view": check('equipment.view'),
  "create": check('equipment.create'),
  "update": check('equipment.update'),
  "delete": check('equipment.delete'),
  "comment": check('equipment.comment'),
  "confirm": check('equipment.confirm'),
  "bundle_lock": check('equipment.bundle_lock'),
  "bundle_unlock": check('equipment.bundle_unlock'),
  "bundle_retire": check('equipment.bundle_retire'),
  "type": {
   "create": check('equipment.type.create'),
   "update": check('equipment.type.update'),
   "delete": check('equipment.type.delete')
  },
  "device": {
   "create": check('equipment.device.create'),
   "update": check('equipment.device.update'),
   "delete": check('equipment.device.delete')
  },
  "brand": {
   "create": check('equipment.brand.create'),
   "update": check('equipment.brand.update'),
   "delete": check('equipment.brand.delete')
  },
  "storage_place": {
   "create": check('equipment.storage_place.create'),
   "update": check('equipment.storage_place.update'),
   "delete": check('equipment.storage_place.delete')
  },
  "calibration": {
   "view": check('equipment.calibration.view'),
   "create": check('equipment.calibration.create'),
   "update": check('equipment.calibration.update'),
   "delete": check('equipment.calibration.delete')
  },
  "product": {
   "view": check('equipment.product.view'),
   "create": check('equipment.product.create'),
   "update": check('equipment.product.update'),
   "delete": check('equipment.product.delete')
  },
  "location": {
   "create": check('equipment.location.create'),
   "update": check('equipment.location.update'),
   "delete": check('equipment.location.delete')
  },
  "team": {
   "create": check('equipment.team.create'),
   "update": check('equipment.team.update'),
   "delete": check('equipment.team.delete')
  },
  "model": {
   "create": check('equipment.model.create'),
   "update": check('equipment.model.update'),
   "delete": check('equipment.model.delete')
  },
  "part": {
   "create": check('equipment.part.create'),
   "update": check('equipment.part.update'),
   "delete": check('equipment.part.delete')
  }
 },
 "refurbishment": {
  "view": check('refurbishment.view'),
  "create": check('refurbishment.create'),
  "update": check('refurbishment.update'),
  "delete": check('refurbishment.delete')
 }
}
}

